// extracted by mini-css-extract-plugin
module.exports = {"container":"filter_dropdown-module__container--P8hxe"};